export const handleSegmentSeek = (playerContext, segment) => (e) => {
    const seekTarget = getSeekTarget(e);
    if (isSeekOutsideSegment(seekTarget, segment)) {
        playerContext.player.seek(clampSeekTarget(seekTarget, segment));
    }
};
export const getSeekTarget = (event) => {
    return event.seekTarget ? event.seekTarget : event.to.time;
};
export const isSeekOutsideSegment = (seekTarget, segment) => {
    return seekTarget > segment.outpoint || seekTarget < segment.inpoint;
};
export const clampSeekTarget = (seekTarget, segment) => {
    return Math.max(segment.inpoint, Math.min(segment.outpoint, seekTarget));
};
